import { createReducer, on } from '@ngrx/store';
import { resetContract, setContract } from './contracts.actions';
import { IPolicyCompleteData } from './contracts.models';

export const initialState: IPolicyCompleteData = null;

export const contractsReducers = createReducer(
  initialState,

  on(setContract, (state, { contractSelected }) => contractSelected ),
  on(resetContract, (state) => initialState)
);
